import { Box } from '@mui/material';

import type { BoxProps } from '@mui/system';
import type { FC } from 'react';


interface EdgeGradient extends Omit<BoxProps, 'top' | 'bottom' | 'left' | 'right'> {
  gradient: {
    from: string;
    to: string;
    hint: string;
  };
  height: string;
}

export interface EdgeGradientTransitionProps
  extends Omit<BoxProps, 'top' | 'bottom' | 'left' | 'right'> {
  top: EdgeGradient;
  bottom: EdgeGradient;
  right: EdgeGradient;
  left: EdgeGradient;
}

const defaultGradients: EdgeGradientTransitionProps = {
  top: {
    gradient: {
      from: '255,255,255,0',
      to: '255,255,255,1',
      hint: '70%',
    },
    height: '100%',
  },
  bottom: {
    gradient: {
      from: '255,255,255,0',
      to: '255,255,255,1',
      hint: '30%',
    },
    height: '100%',
  },
  right: {
    gradient: {
      from: '255,255,255,0',
      to: '255,255,255,1',
      hint: '30%',
    },
    height: '100%',
  },
  left: {
    gradient: {
      from: '255,255,255,0',
      to: '255,255,255,1',
      hint: '70%',
    },
    height: '100%',
  },
};

export const EdgeGradientTransition: FC<EdgeGradientTransitionProps> = ({
  children,
  top,
  bottom,
  left,
  right,
  ...props
}) => (
  <Box
    width="auto"
    height="auto"
    position="relative"
    zIndex={2}
    {...props}
  >
    {top &&
      <Box
        position="absolute"
        top={0}
        width="100%"
        sx={{
          background: `linear-gradient(to top,rgba(${top.gradient.from}), rgba(${top.gradient.to}) ${top.gradient.hint})`,
          // background: `linear-gradient(to top,rgba(${top.gradient.from}), rgba(${top.gradient.to})70%)`
        }}
        zIndex={1}
        {...top}
      />}
    {left &&
      <Box
        position="absolute"
        width="100px"
        sx={{
          background: `linear-gradient(to left,rgba(${left.gradient.from}), rgba(${left.gradient.to}) ${left.gradient.hint})`,
        }}
        zIndex={1}
        {...left}
      />}
    {right &&
      <Box
        position="absolute"
        right={0}
        width="100px"
        sx={{
          background: `linear-gradient(to right,rgba(${right.gradient.from}), rgba(${right.gradient.to}) ${right.gradient.hint})`,
        }}
        zIndex={1}
        {...right}
      />}
    {bottom &&
      <Box
        position="absolute"
        bottom={0}
        width="100%"
        sx={{
          background: `linear-gradient(to bottom,rgba(${bottom.gradient.from}), rgba(${bottom.gradient.to}) ${bottom.gradient.hint})`,
        }}
        zIndex={1}
        {...bottom}
      />}
    {children}
  </Box>
);
